<script setup lang="ts" generic="T extends KeyValueRow">
import type { KeyValueRow } from './types';

defineProps<{
  rows: T[];
  // Optional column headers; the header row only appears when at least one is given.
  labelHeader?: string;
  valueHeader?: string;
}>();

defineSlots<{
  label?: (props: { row: T }) => unknown;
  value?: (props: { row: T }) => unknown;
}>();
</script>

<template>
  <v-table density="compact">
    <thead v-if="labelHeader || valueHeader">
      <tr>
        <th scope="col" class="ps-0 py-2 border-b font-weight-bold text-start">
          {{ labelHeader }}
        </th>
        <th scope="col" class="ps-0 pe-0 py-2 border-b font-weight-bold text-right">
          {{ valueHeader }}
        </th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(row, index) in rows" :key="index">
        <th scope="row" class="ps-0 py-2 border-b font-weight-regular text-start">
          <slot name="label" :row="row">{{ row.label }}</slot>
        </th>
        <td class="ps-0 pe-0 py-2 border-b text-right">
          <slot name="value" :row="row">{{ row.value }}</slot>
        </td>
      </tr>
    </tbody>
  </v-table>
</template>
